import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class EcosystemFragmentationUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'ecosystem-fragmentation'
  readonly name = 'Fragmentación de Ecosistemas Estratégicos'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
